import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './curriculum-tree-year.reducer';

export const selectCurriculumTreeYearState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectCurriculumTreeYearState, (state: State) => state.error);

export const getLoaded = createSelector(selectCurriculumTreeYearState, (state: State) => state.loaded);

export const getAll = createSelector(selectCurriculumTreeYearState, selectAll);

export const getCount = createSelector(selectCurriculumTreeYearState, selectTotal);

export const getIds = createSelector(selectCurriculumTreeYearState, selectIds);

export const getAllEntities = createSelector(selectCurriculumTreeYearState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * curriculumTreeYear$: CurriculumTreeYearInterface[] = this.store.pipe(
    select(CurriculumTreeYearQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectCurriculumTreeYearState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * curriculumTreeYear$: CurriculumTreeYearInterface = this.store.pipe(
    select(CurriculumTreeYearQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectCurriculumTreeYearState,
  (state: State, props: { id: number }) => state.entities[props.id]
);
